import styled from "styled-components";

export const Container = styled.div`
  .ant-row,
  .ant-row-flex {
    width: 100%;
  }
`;
